/* eslint-disable */
import { isNil } from 'lodash-es';
import { prop } from 'lodash/fp';
import { DateTime } from 'luxon';

type SignGetterFn<T, R> = (data: T, v?: unknown) => R;

type SignGetter<T, R> = SignGetterFn<T, R> | boolean;

export type Format<T, R> = (
  path: string,
  format?: boolean | SignGetterFn<T, R>,
  strict?: boolean
) => string | number;

interface FormatFactory {
  <T, R>(
    obj: T,
    getter?: (v: T, value?: unknown) => R,
    defaultFormatter?: (v: T, value?: unknown) => R
  ): Format<T, R>;
  Currency: SignGetterFn<unknown, string>;
  Blank: SignGetterFn<unknown, string | number>;
  Temp: SignGetterFn<unknown, string>;
  DateTime: SignGetterFn<unknown, string>;
  Date: SignGetterFn<unknown, string>;
  Boolean: (yes: string, no: string) => SignGetterFn<unknown, string>;
  Suffix: (value: string) => SignGetterFn<unknown, string>;
}

function isSignGetter<T, R>(
  value: SignGetter<T, R>
): value is SignGetterFn<T, R> {
  return typeof value === 'function';
}

/**
 * @deprecated
 *
 * @param {*} obj
 * @param {*} [getSign=getFormatter.Currency]
 * @param {SignGetter<any, any>} [defaultFormatter=true]
 * @returns
 */
export const getFormatter: FormatFactory =
  (
    obj,
    // @ts-ignore
    getSign = getFormatter.Currency,
    defaultFormatter: SignGetter<any, any> = true
  ) =>
  <R>(
    path: string,
    format: SignGetter<any, R> = defaultFormatter,
    strict = false
  ) => {
    const value = prop(path, obj);
    if (strict ? !value : value === undefined) return '';
    if (!format) {
      return value;
    }
    const signGetter = isSignGetter(format) ? format : getSign;
    if (
      [
        getFormatter.Date,
        getFormatter.Blank,
        getFormatter.DateTime,
        getFormatter.Temp
        // @ts-ignore
      ].includes(signGetter)
    )
      return signGetter(value);
    return signGetter(obj, value);
  };

getFormatter.Blank = (v) => v as string;
getFormatter.Suffix = (suffix) => (_, v) => `${v}${suffix}`;
getFormatter.Currency = (d, v) => `${v}${prop('Currency.Sign', d)}`;
getFormatter.Temp = (v) => {
  if (isNil(v)) return '';
  if (+(v as number) >= 255 || +(v as number) < -40) return '';
  return getFormatter.Suffix('°C')(undefined, v);
};
getFormatter.DateTime = (v: unknown) => {
  try {
    return DateTime.fromMillis(parseInt(v as string, 10)).toFormat(
      'dd.MM.yy, T'
    );
  } catch (e) {
    return v as string;
  }
};
getFormatter.Date = (v: unknown) => {
  try {
    return DateTime.fromMillis(parseInt(v as string, 10)).toFormat('D');
  } catch (e) {
    return v as string;
  }
};
getFormatter.Boolean = (yes, no) => (_, v) => (v ? yes : no);
